import { render, staticRenderFns } from "./ArrivalsList.vue?vue&type=template&id=7cf90cf2&scoped=true&"
import script from "./ArrivalsList.vue?vue&type=script&lang=js&"
export * from "./ArrivalsList.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalsList.vue?vue&type=style&index=0&id=7cf90cf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf90cf2",
  null
  
)

export default component.exports